import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, fontSize } = theme.tokens;
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: 16
    },
    titleRow: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "flex-end",
      gap: 16
    },
    titles: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      minWidth: 0
    },
    title: {
      margin: 0,
      fontSize: fontSize.h1,
      fontWeight: 800,
      letterSpacing: "-0.01em",
      lineHeight: 1.2,
      color: color.ink,
      [theme.media.phone]: { fontSize: fontSize.mobile.h1 }
    },
    subtitle: {
      fontSize: fontSize.body,
      color: color.muted
    }
  };
});

export default withCustomStyles;
